import { NavDropdown } from "react-bootstrap";
import More from "assets/images/svg/more.svg";
import { formatDate, json } from "helpers/data";
import _NotificationsService, { GetNotificationsRoutes } from "services/notifications-services";
import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "components/form";

export const NotificationCard = ({ item }) => {
  const { t } = useTranslation("home");
  const queryClient = useQueryClient();
  const navigate= useNavigate()

  const markRead = () => {
    _NotificationsService.markRead(item?.id).then(() => {
      queryClient.invalidateQueries(["notifications"]);
      queryClient.invalidateQueries(["notifications-length"]);
    });
  };
  const hide = () => {
    _NotificationsService.hideNotify(item?.id).then(() => {
      queryClient.invalidateQueries(["notifications"]);
      queryClient.invalidateQueries(["notifications-length"]);
    });
  };
  const onClickNotification=(item)=>{
    markRead()
    navigate(GetNotificationsRoutes(item)?.route)
  }
  return (
    <div  className={item.isRead ? "content read" : "content"}>
      <div onClick={()=>onClickNotification(item)}>
        <p className="info">
          <span>{json(item?.actionTypeName)}</span> {json(item?.description)}
        </p>
        <span className="date">{formatDate(item?.createDate, { showTime: true })}</span>
      </div>
      <div>
        <NavDropdown title={<img src={More} alt="IconProfile" />} id="basic-nav-dropdown" className="more">
          {!item?.isRead && <Button className="btn-blue-light" onClick={() => markRead()}> {t("navbar.notifications.markAsRead")}</Button>}
          <Button className="btn-blue-light" onClick={() => hide()}>{t("navbar.notifications.hide")}</Button>
        </NavDropdown>
      </div>
    </div>
  );
};
